import { Nav, Navbar } from 'react-bootstrap';
import React from 'react';
import { HOAppSwitcher as AppSwitcher } from '../AppSwitcher/AppSwitcher';
import logo from './hetzner-logo.svg';
import * as PropTypes from 'prop-types';
import iconRobot from '../AppSwitcher/icon-hetzner-robot.svg';
import iconCloud from '../AppSwitcher/icon-hetzner-cloud.svg';
import iconWebsite from '../AppSwitcher/icon-hetzner-website.svg';
var defaultAppSwitcherItems = [
    {
        url: 'https://robot.your-server.de/',
        name: 'Robot',
        logo: iconRobot,
        alt: 'Icon Robot Hetzner'
    },
    {
        url: 'https://console.hetzner.cloud/',
        name: 'Cloud',
        logo: iconCloud,
        alt: 'Icon Hetzner Cloud'
    },
    {
        url: 'https://www.hetzner.com/',
        name: 'Website',
        logo: iconWebsite,
        alt: 'Icon Hetzner Website',
        isExternal: true
    }
];
var HONavBar = function (props) {
    var siteTitle = props.siteTitle, hasAppSwitcher = props.hasAppSwitcher, appSwitcherItems = props.appSwitcherItems;
    hasAppSwitcher = hasAppSwitcher || false;
    return (React.createElement("header", null,
        React.createElement(Navbar, { bg: 'white', className: 'py-0 shadow-sm', style: { height: '64px', padding: '25px' } },
            React.createElement(Navbar.Brand, { href: '/', className: 'd-flex align-items-center mr-0 py-0 mr-4 border-right-1' },
                React.createElement("img", { className: 'logo-top-bar', height: 21, src: logo, alt: 'Logo Hetzner Online GmbH' }),
                React.createElement("strong", { className: 'd-none d-sm-block ml-2 h5 mb-0' }, siteTitle)),
            React.createElement(Navbar.Collapse, { id: 'main-navbar' },
                React.createElement(Nav, { className: 'mr-auto' }),
                hasAppSwitcher && (React.createElement(AppSwitcher, { items: appSwitcherItems || defaultAppSwitcherItems, alignRight: true }))))));
};
export { HONavBar };
HONavBar.propTypes = {
    siteTitle: PropTypes.string,
    hasAppSwitcher: PropTypes.bool,
    appSwitcherItems: PropTypes.array
};
